import React, { Component } from 'react'
import logo from '../../assets/images/Godrej_Logo.png';
import './Header.css';
import HeaderDetails from './HeaderDetails';

export default class Header extends Component {
  render() {
    const { user } = this.props;
    const roleMap = { user: 'User', divadmin: 'Division Administrator' };
    const displayRole = roleMap[user?.role_code?.toLowerCase()] || user?.role_code;
    return (
            <header className='header-container'>
            <div className="header-left">
                <img src={logo} className="App-logo" alt="logo" />
              </div>
              <div className='header-center'>
                <h1 className="App-heading">
                  Asset Management System
                </h1>
                </div>
                <div className='header-right'>
                    <HeaderDetails user={user?.user_id || user?.name} role={displayRole}/>
                </div>
                <hr className='Header-line'/>
            </header>
            )
  }
}
